import { oidcConfig } from "@/shared/auth/authConfig";
import { useNetworkStatus } from "@/shared/hooks/useNetworkStatus";

export function useOidcConfig() {
  const { isOnline } = useNetworkStatus();

  return {
    ...oidcConfig,
    automaticSilentRenew: isOnline,
  };
}
